import React from "react";
import Form from "react-bootstrap/Form";
import "./FloatLabel.css";

export default function FloatLabelTextBox(props) {
    return (
        <>
            <div className="floating-label">
                <Form.Control
                    data-testid={props.inputName}
                    id={props.inputName}
                    autoFocus={props.inputAutofocus}
                    type={props.inputType}
                    placeholder={props.inputPlaceholder}
                    value={props.inputValue}
                    name={props.inputName}
                    onChange={(e) => props.handleChangeProps(e)}
                    className={props.inputClassName}
                    disabled={props.inputDisabled}
                    rows={props.inputRows}
                    as={props.inputAs}
                    spellCheck={props.inputSpellCheck}
                />
                <label className="textbox-floating-label" htmlFor={props.inputName}>{props.inputLabel}</label>         
            </div>
            {props.inputHelperText !== undefined && props.inputHelperText.length > 0 ? (
                <Form.Text className={props.inputClassName}>{props.inputHelperText}</Form.Text>
            ) : (
                <></>
            )}            
        </>
    );
}